import spacetime from 'spacetime';

function cloneDeep(object) {
  return JSON.parse(JSON.stringify(object));
}

export function rateRequestFromQuote(quote, transaction_type, paymentFrequency) {
  if (!quote || !quote.coverages || !quote.coverages[0] || !quote.customer) {
    throw new Error('Could not find coverage or customer in quote');
  }

  console.log('quote for rating', quote);
  console.log('rateRequestFromCoverage paymentFrequency is: ', paymentFrequency);

  const referrerName = quote.referrer_name;

  const createDate = quote.create_date
    ? spacetime(quote.create_date).format('iso-short')
    : spacetime.now('UTC').format('iso-short');

  return rateRequestFromCoverage(
    quote.coverages[0],
    quote.customer,
    transaction_type,
    createDate,
    referrerName,
    paymentFrequency
  );
}

export function rateRequestFromCoverage(
  coverage,
  customer,
  transaction_type,
  createDate,
  referrerName,
  paymentFrequency
) {
  if (!coverage || !customer) {
    throw new Error('Coverage or customer not supplied');
  }

  if (referrerName && referrerName.includes('Pulse')) {
    customer.pulse_account_active = true;
  }

  if (referrerName && referrerName.includes('Grey Power')) {
    customer.grey_power_account_active = true;
  }

  if (referrerName && referrerName == 'Sharesies') {
    customer.sharesies_account_active = true;
  }

  if (!createDate) {
    createDate = coverage.create_date
      ? spacetime(coverage.create_date).format('iso-short')
      : spacetime.now('UTC').format('iso-short');
  }

  const dateNow = spacetime.now('Pacific/Auckland').format('iso-short');

  // Copy objects in place
  const convertedCoverage = cloneDeep(coverage);
  convertedCoverage.payment_frequency = paymentFrequency;
  console.log('convertedCoverage is: ', convertedCoverage);

  convertedCoverage.create_date = createDate;
  convertedCoverage.referrer_name = referrerName ? referrerName : '';
  console.log('converted coverage', convertedCoverage);

  console.log('converted coverage', convertedCoverage);
  convertedCoverage.customer = cloneDeep(customer);

  // Delete stuff we don't need
  delete convertedCoverage.expiry_date;
  //delete convertedCoverage.premium;
  delete convertedCoverage.prorated_premium;
  delete convertedCoverage.to_pay;

  // Copy coverage location
  convertedCoverage.location = convertedCoverage.risk.location;
  delete convertedCoverage.risk.location;

  // Reduced excesses to a single selected excess
  let selectedExcess = convertedCoverage.excesses.reduce((selectedExcess, excess) =>
    excess.selected ? excess : selectedExcess
  );

  convertedCoverage.excesses = [selectedExcess];

  if (convertedCoverage.risk.pet) {
    //mapping for pet body
    convertedCoverage.coverage_type = convertedCoverage.risk.coverage_type;
    convertedCoverage.excess = selectedExcess.amount;
    convertedCoverage.copay = convertedCoverage.risk.copay;
  }

  // Delete uneccesary fields in coverages
  convertedCoverage.coverages = convertedCoverage.coverages.reduce((newCoverages, c) => {
    if (c.is_selectable === 'Y') newCoverages.push({ code: c.code, selected: c.selected });
    return newCoverages;
  }, []);

  // Convert dates
  if (convertedCoverage.start_date) {
    convertedCoverage.start_date = spacetime(convertedCoverage.start_date, 'UTC').format(
      'iso-short'
    );
  } else {
    convertedCoverage.start_date = dateNow;
  }

  //If future start date, must be a quote so use start date to pickup future rate changes
  //otherwise is MTA so use current date
  const effective_date =
    convertedCoverage.start_date > dateNow ? convertedCoverage.start_date : dateNow;

  convertedCoverage.rate_effective_date = spacetime(
    convertedCoverage.rate_effective_date,
    'UTC'
  ).format('iso-short');

  convertedCoverage.inception_date = spacetime(convertedCoverage.inception_date, 'UTC').format(
    'iso-short'
  );

  convertedCoverage.customer.date_of_birth = spacetime(
    convertedCoverage.customer.date_of_birth,
    'UTC'
  ).format('iso-short');

  // #justvehiclestuff
  if (convertedCoverage.risk.vehicle) {
    convertedCoverage.drivers = convertedCoverage.risk.drivers;
    delete convertedCoverage.risk.drivers;
    convertedCoverage.drivers.forEach(driver => {
      driver.driver_type = driver.type;
      delete driver.type;
    });

    convertedCoverage.excess = convertedCoverage.excesses[0].amount;
    delete convertedCoverage.excesses;

    convertedCoverage.usage = convertedCoverage.risk.usage;
    delete convertedCoverage.risk.usage;
  }

  return { coverage: convertedCoverage, transaction_type, effective_date };
}
